<div class="ui-g">
  <div class="ui-g-12">
    <div class="card card-w-title">
      <h1>Manage License Types</h1>

      <form (ngSubmit)="search()" style="width: 100%">
        <div class="ui-g filterPanel form-group">
          <div class="ui-g-12 ui-md-4 ui-lg-2">
            <span class="md-inputfield filterItem">
              <input
                name="name"
                type="text"
                pInputText
                [(ngModel)]="filterVal.filters.name.value"
              />
              <label>Name</label>
            </span>
          </div>

          <div class="ui-g-12 ui-md-4 ui-lg-2">
            <span class="md-inputfield filterItem">
              <input
                name="description"
                type="text"
                pInputText
                [(ngModel)]="filterVal.filters.description.value"
              />
              <label>Description</label>
            </span>
          </div>

          <div class="ui-g-12 ui-md-4 ui-lg-2">
            <button pButton type="submit" label="Search"></button>
            <button pButton type="button" label="Clear" (click)="clearFilter()"></button>
          </div>
        </div>
      </form>

      <p-table
        selectionMode="single"
        [value]="page.items"
        [lazy]="true"
        [rows]="10"
        [responsive]="true"
        [paginator]="true"
        rowHover="true"
        resizableColumns="true"
        [totalRecords]="page.total"
        (onLazyLoad)="onGridLazyLoad($event)"
        (onRowSelect)="onRowSelect($event)"
        [rowsPerPageOptions]="[5, 10, 20]"
        [pageLinks]="3"
        *ngIf="isLoaded; else loading"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Name</th>
            <th>Description</th>
            <th>Active</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr [pSelectableRow]="item" (dblclick)="onRowDblclick(item)">
            <td>{{ item.name }}</td>
            <td>{{ item.description }}</td>
            <td>{{ item.isActive }}</td>
          </tr>
        </ng-template>
      </p-table>

      <!-- DATATABLE DEPRECATED --
      <p-dataTabl selectionMode="single" [value]="page.items" [lazy]="true" [rows]="10" [responsive]="true" [paginator]="true" rowHover="true" resizableColumns="true"
                   [totalRecords]="page.total" (onLazyLoad)="onGridLazyLoad($event)" (onRowSelect)="onRowSelect($event)" (onRowDblclick)="onRowDblclick($event)" [rowsPerPageOptions]="[5,10,20]" [pageLinks]="3"
                   *ngIf="isLoaded; else loading">
          <p-column field="name" header="Name" [sortable]="true" [editable]="false" [style]="{'width': '45%'}"></p-column>
          <p-column field="description" header="Description" [sortable]="true" [editable]="false" [style]="{'width': '45%'}"></p-column>
          <p-column field="isActive" header="Active" [sortable]="true" [editable]="false" [style]="{'width': '10%'}"></p-column>
      </p-dataTable>
      --->

      <div class="footerPanel ui-grid-row">
        <button
          type="button"
          class="btn-to-right"
          pButton
          (click)="onEdit()"
          label="Edit"
          icon="fa ui-icon-mode-edit"
        ></button>
        <button
          type="button"
          class="btn-to-right"
          pButton
          icon="fa ui-icon-add"
          (click)="showDialogToAdd()"
          label="Add"
        ></button>
      </div>

      <p-dialog
        header="License Type"
        [(visible)]="displayDialog"
        [responsive]="true"
        [modal]="true"
        [style]="{ width: '400px' }"
      >
        <form
          [formGroup]="newLicenseTypesForm"
          (ngSubmit)="save(newLicenseTypesForm.value)"
          autocomplete="off"
        >
          <div class="ui-grid ui-grid-responsive ui-fluid" *ngIf="license">
            <div class="ui-g-12">
              <div class="ui-g-4"><label for="name">Name</label></div>
              <div class="ui-g-8"><input pInputText id="name" formControlName="name" /></div>
            </div>
            <div class="ui-g-12">
              <div class="ui-g-4"><label for="description">Description</label></div>
              <div class="ui-g-8">
                <input pInputText id="description" formControlName="description" />
              </div>
            </div>
            <div class="ui-g-12">
              <div class="ui-g-4"><label for="isactive">Active</label></div>
              <div class="ui-g-8">
                <p-checkbox
                  name="isActive"
                  id="isactive"
                  binary="true"
                  formControlName="isActive"
                ></p-checkbox>
              </div>
            </div>
          </div>

          <div style="float: right">
            <button
              type="submit"
              class="green-btn"
              pButton
              icon="fa ui-icon-check"
              label="Save"
              [disabled]="newLicenseTypesForm.invalid"
            ></button>
            <button
              type="button"
              pButton
              icon="fa ui-icon-close"
              label="Cancel"
              (click)="close()"
            ></button>
          </div>
        </form>
      </p-dialog>
    </div>
  </div>
</div>
<ng-template #loading>Loading...</ng-template>
